import { defineField, defineType } from 'sanity'
import { findParentsParent } from '../../utils/findParentsParent'

export default defineType({
  title: 'Available Wheel Designs',
  name: 'availableWheelDesigns',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Available Wheel Designs',
    }),
    defineField({
      title: 'Designs',
      name: 'designs',
      type: 'array',
      validation: (rule) => rule.min(1).max(2).required(), // only 2 construction types available
      of: [
        {
          type: 'object',
          name: 'designGroupItem',
          fields: [
            defineField({
              title: 'Construction type',
              name: 'constructionType',
              type: 'string',
              options: {
                list: [
                  { title: 'Flow Formed', value: 'Flow Formed' },
                  { title: 'Forged', value: 'Forged' },
                ],
                layout: 'radio',
              },
              readOnly: ({ parent }) => !!parent.wheels?.length,
              validation: (rule) => rule.required(),
            }),
            defineField({
              title: 'Wheels',
              name: 'wheels',
              type: 'array',
              of: [
                {
                  title: 'Wheel',
                  name: 'wheel',
                  type: 'reference',
                  to: [{ type: 'design' }],
                  options: {
                    filter: ({ document, parentPath }) => {
                      const design = findParentsParent({
                        parentPath,
                        document,
                        level: 1,
                      })

                      return {
                        filter: `($constructionType == '' || line->construction == $constructionType) && !(_id in path("drafts.**")) && !(_id in $usedWheels)`,
                        params: {
                          constructionType: design?.constructionType || '',
                          usedWheels:
                            design?.wheels?.map((wheel) => wheel?._ref) || [],
                        },
                      }
                    },
                  },
                },
              ],
            }),
          ],
        },
      ],
    }),
    defineField({
      title: 'Common features',
      name: 'commonFeatures',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'commonFeatureItem',
          fields: [
            defineField({
              title: 'Name',
              name: 'name',
              type: 'string',
            }),
            defineField({
              title: 'Value',
              name: 'value',
              type: 'string',
            }),
          ],
          preview: {
            select: {
              name: 'name',
              value: 'value',
            },
            prepare({ name, value }) {
              return {
                title: name || 'Untitled',
                subtitle: value || 'Undefined',
              }
            },
          },
        },
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title: `${title}` || 'Untitled',
        subtitle: 'Available Wheel Designs',
      }
    },
  },
})